import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const NEWS = [{
  id: 1,
  tag: 'Noticia',
  date: '12 Oct 2023',
  title: 'Avanza el ordenamiento territorial en la Amazonía',
  image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80'
}, {
  id: 2,
  tag: 'Evento',
  date: '28 Sep 2023',
  title: 'Encuentro de saberes interculturales',
  image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&q=80'
}, {
  id: 3,
  tag: 'Comunicado',
  date: '15 Sep 2023',
  title: 'Nuevos acuerdos con Parques Nacionales',
  image: 'https://images.unsplash.com/photo-1511497584788-876760111969?auto=format&fit=crop&q=80'
}, {
  id: 4,
  tag: 'Noticia',
  date: '02 Sep 2023',
  title: 'Entregados productos cartográficos del IGAC',
  image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&q=80'
}, {
  id: 5,
  tag: 'Evento',
  date: '20 Ago 2023',
  title: 'Jornada de reforestación comunitaria',
  image: 'https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&q=80'
}, {
  id: 6,
  tag: 'Comunicado',
  date: '05 Ago 2023',
  title: 'Balance positivo del primer semestre',
  image: 'https://images.unsplash.com/photo-1470071131384-001b85755b36?auto=format&fit=crop&q=80'
}];
export function NewsGrid() {
  return <section id="noticias" className="py-16 md:py-20 px-4 md:px-8" data-id="element-257">
      <div className="max-w-[1400px] mx-auto" data-id="element-258">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4" data-id="element-259">
          <div data-id="element-260">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-3" data-id="element-261">
              Archivo
            </span>
            <h2 className="text-2xl md:text-3xl font-serif text-forest" data-id="element-262">
              Otras noticias y eventos
            </h2>
          </div>
          <a href="#" className="text-charcoal/70 hover:text-clay font-medium flex items-center gap-2 transition-colors text-sm" data-id="element-263">
            Ver todas <ArrowRight size={16} data-id="element-264" />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-id="element-265">
          {NEWS.map((item, index) => <motion.a key={item.id} href="#" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="group flex flex-col" data-id="element-266">
              <div className="relative aspect-[4/3] overflow-hidden mb-3 bg-bone-dark" data-id="element-267">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-268" />
                <div className="absolute top-2 left-2 bg-bone/95 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-forest" data-id="element-269">
                  {item.tag}
                </div>
              </div>
              <span className="text-clay text-[11px] font-medium tracking-wide mb-1" data-id="element-270">
                {item.date}
              </span>
              <h3 className="text-sm font-serif text-forest leading-snug group-hover:text-clay transition-colors line-clamp-3" data-id="element-271">
                {item.title}
              </h3>
            </motion.a>)}
        </div>
      </div>
    </section>;
}